/**
 * Paginate a subgraph query, optionally capped at `max` total results.
 * Calls `fetcher(skip, first)` in a loop until either the page is short
 * (no more results) or the cap is reached. Pass `max = Infinity` to fetch
 * exhaustively.
 */
export async function paginateAll<T>(
  fetcher: (skip: number, first: number) => Promise<T[]>,
  batchSize = 1000,
  max = Infinity,
  initialSkip = 0,
): Promise<T[]> {
  const results: T[] = [];
  let skip = initialSkip;

  while (results.length < max) {
    const remaining = max - results.length;
    const fetchSize = Math.min(batchSize, remaining);
    const page = await fetcher(skip, fetchSize);
    results.push(...page);
    if (page.length < fetchSize) break;
    skip += fetchSize;
  }

  return results;
}
